import api from "@src/api/api";
import { User } from "@src/utils/user";
import { useQuery } from "@tanstack/react-query";

export const useUser = (id: string) => {
  return useQuery<User, Error>(
    ["user", `user-${id}`],
    async () => {
      const res = await api.get(`/api/v1/users/${id}`);
      return res.data.data;
    },
    {
      retry: false,
    },
  );
};

export default useUser;
